import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
    previousPage: string,
    currentPage: string,
    previousPageUrl: string
}

const HeaderWithBack = ({previousPage, currentPage, previousPageUrl}: Props) => {
  return (
    <div className="w-11/12 flex items-center gap-3">
      <Link
        to={`${previousPageUrl}`}
        className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-hair bg-surface text-ink shadow-card transition hover:bg-canvas active:scale-95"
        aria-label={`Back to ${previousPage}`}
      >
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </Link>
      <nav className="flex items-center gap-2 text-sm">
        <Link to={`${previousPageUrl}`} className="font-medium text-categoriesTextColor hover:text-ink transition-colors">
          {previousPage}
        </Link>
        <span className="text-hair">/</span>
        <span className="font-display font-semibold text-ink">{currentPage}</span>
      </nav>
    </div>
  )
}

export default HeaderWithBack
